
/**
 * @name: Deferred
 * @intent: Create a static Promise and defer its fulfillment or rejection so that these operations may be performed later.
 * @patterns: { Template Method }
 */
 class Deferred {
    private _resolve: Function = () => {};  // Hook Method
    private _reject: Function = () => {};  // Hook Method
    public promise: Promise<any> = new Promise( this.executor.bind(this) );
    
    constructor() {
      Object.freeze(this);
    }
    
    executor(resolve, reject) {
      this._resolve = resolve;
      this._reject = reject;
    }
    
    resolve(...args) {  // Template Method
      return this._resolve(...args);
    }
    reject(...args) {  // Template Method
      return this._reject(...args);
    }
    
  }
  
  export { Deferred };
  